import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { fromJS } from 'immutable';

export default (file, clientId, divisionId, senderid, sender, scheduleDate, scheduleTime) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'check-contact-upload-file';
   // const url = 'http://192.168.181.112/dummyWA/check-contact-upload.php'
    const data = new FormData();
    data.append('file', file );
    //tambahan
    data.append('client-id',clientId)
    data.append('division-id',divisionId)
    data.append('sender-id',senderid)
    data.append('sender-name',sender)
    data.append('schedule-date',scheduleDate)
    data.append('schedule-time',scheduleTime)
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : data
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });

        if(response.ok){
            var res = fromJS(await response.json());
            res = res.get('upload-files');
            //debugger
            return fromJS({
                'success': true,
                "file-name": res.get('file-name')
            });
        }
    
    return fromJS({
        'success': false
    })
};